import React from "react"
import {Col, Row} from "react-bootstrap"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import InputFieldSkeleton from "../../../components/skeletons/InputFieldSkeleton";

export default function JournalModalSkeleton() {

    return(
        <div className={'journals'} style={{height:'80vh'}}>
            <Row>
                <Col md={12} lg={12} xl={12}>
                    <div className={'type'}>
                        <h4> <HeadingSkeleton height={10} maxWidth={200} block={true}/></h4>
                        <div className={'d-flex align-items-center gap-3'}>
                            <HeadingSkeleton height={70} block={true}/>
                            <HeadingSkeleton height={70} block={true}/>
                            <HeadingSkeleton height={70} block={true}/>
                        </div>
                    </div>
                    <div>
                        <div className={'create-events'}>

                            <Row>
                                <Col md={12}>
                                    {
                                        [1,2,3,4,5,6,7,8].map((item,index)=>{
                                            return(
                                                <InputFieldSkeleton key={index} labelWidth={400}/>
                                            )
                                        })
                                    }
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <div className={''}>
                                        <p className={'form-mess'}> <HeadingSkeleton height={10} maxWidth={700}/></p>
                                    </div>
                                    <div className={'d-flex flex-column mt-4'}>
                                        <HeadingSkeleton height={60} />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>


        </div>
    )
}